module.exports = __webpack_public_path__ + "static/ws_logo-dfd1c1f26a98cfb117e05040df91b99c.png";